export const handlePostAlertSignup = () => {
    addEmailPlaceholder();
    addSelectPlaceholders();
};

const addEmailPlaceholder = () => {
    const input = document.querySelector<HTMLInputElement>(".edit-post-alert__form-group--email input");
    if (input) input.placeholder = "Email address";
};

const onElementReady = (parent: Element, selector: string, callback: (el: HTMLElement) => void) => {
    const el = parent.querySelector<HTMLElement>(selector);
    if (el) return callback(el);

    const observer = new MutationObserver(() => {
        const el = parent.querySelector<HTMLElement>(selector);
        if (el) {
            observer.disconnect();
            callback(el);
        }
    });
    observer.observe(parent, { childList: true, subtree: true });
};

const ensureSpan = (parent: HTMLElement, className: string, text: string) => {
    let el = parent.querySelector<HTMLElement>(`.${className}`);
    if (!el) {
        el = document.createElement("span");
        el.className = className;
        el.textContent = text;
        parent.prepend(el);
    }
    return el;
};

const addSelectPlaceholders = () => {
    const widget = document.querySelector(".post-alert-signup-widget");
    if (!widget) return;

    const attachPlaceholder = (groupSelector: string, text: string) => {
        const group = widget.querySelector(groupSelector);
        const select = group?.querySelector<HTMLSelectElement>("select");
        if (!group || !select) return;

        onElementReady(group, ".select2-selection__rendered", (rendered) => {
            const updateVisibility = () => {
                const searchField = rendered.querySelector<HTMLInputElement>(".select2-search__field");
                const hasInput = !!searchField?.value?.trim();
                const hasSelection = Array.from(select.selectedOptions).some((o) => !!o.value);
                ensureSpan(rendered, "edit-post-alert__select-placeholder", text).style.display =
                    hasSelection || hasInput ? "none" : "inline";
            };

            select.addEventListener("change", updateVisibility);
            new MutationObserver(updateVisibility).observe(rendered, { childList: true, subtree: true });
            updateVisibility();
        });
    };

    attachPlaceholder(".edit-post-alert__form-group--tags", "Tags");
    attachPlaceholder(".edit-post-alert__form-group--category", "Category");
};